import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { CycleSection } from './components/CycleSection';
import { ProductIntroSection } from './components/ProductIntroSection';
import { LevelsSection } from './components/LevelsSection';
import { BonusSection } from './components/BonusSection';
import { WhyWorksSection } from './components/WhyWorksSection';
import { ComparisonSection } from './components/ComparisonSection';
import { ResultsSection } from './components/ResultsSection';
import { ForWhoSection } from './components/ForWhoSection';
import { OfferSection } from './components/OfferSection';
import { FinalCTASection } from './components/FinalCTASection';
import { MiniTestimonial } from './components/MiniTestimonial';
import { TestimonialsSection } from './components/TestimonialsSection';
import { MockupSection } from './components/MockupSection';
import { InlineCTA } from './components/InlineCTA';
const META_PIXEL_ID = '1369612068384467';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      // Official Meta Pixel snippet — guarded so it can never block render
      ;
      (function (f: any, b, e, v, n?: any, t?: any, s?: any) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', META_PIXEL_ID);
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      // Never let analytics break the page
      console.error('Meta Pixel failed to load', err);
    }
  }, []);
  return <div className="w-full min-h-screen bg-[#0a0a0a] text-white" data-id="element-0">
      {/* HOOK + PRODUCT REVEAL */}
      <HeroSection data-id="element-1" />
      <MockupSection data-id="element-2" />

      {/* PROBLEM AWARENESS */}
      <ProblemSection data-id="element-3" />

      {/* SOLUTION REVEAL */}
      <ProductIntroSection data-id="element-4" />

      <MiniTestimonial quote="El módulo de control y respiración cambió totalmente cómo entro a la intimidad." name="Tomás" age={31} data-id="element-5" />

      <BonusSection data-id="element-6" />

      {/* RESULTADOS + OFERTA (la oferta ya no aparece tan arriba) */}
      <ResultsSection data-id="element-7" />
      <OfferSection data-id="element-8" />

      {/* SOCIAL PROOF */}
      <TestimonialsSection data-id="element-9" />

      {/* REFUERZO */}
      <WhyWorksSection data-id="element-10" />
      <ComparisonSection data-id="element-11" />
      <ForWhoSection data-id="element-12" />

      {/* CIERRE */}
      <FinalCTASection data-id="element-13" />
    </div>;
}